import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { T, useTranslate } from 'shared/helper/translate';
var RubriqUploadButton = function RubriqUploadButton(_ref) {
  var hasFile = _ref.hasFile,
    onClick = _ref.onClick,
    isDragActive = _ref.isDragActive,
    disabled = _ref.disabled,
    onDragStatusChanged = _ref.onDragStatusChanged;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  useEffect(function () {
    onDragStatusChanged(isDragActive);
  }, [isDragActive]);
  if (hasFile) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 text-center"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-file-arrow-up",
    className: "text text-center text-secondary",
    fontSize: "2rem"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('curie-file-upload-text'),
    className: "rubriq-editing-upload-button text-start w-100 mt-1 border-0 d-block text-dark text-center ".concat(isDragActive ? 'hovered' : ''),
    disabled: disabled,
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "curie-file-upload-text"
  })))));
};
export default RubriqUploadButton;